import React, { useState } from 'react'
import { toast } from 'react-toastify';
import AxiosInstance from '../Utility/AxiosInstance';
import BaseUrl from '../../base-api';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { isloading } from '../redux/reducer/LoadingReducer';
import { useDispatch } from 'react-redux';
import { downloadRegistrationPdf } from '../Utility/downloadRegistrationPdf';

const EmployeeCapfFormView = ({ data, showDownloadButton = true }) => {
  
const [pdfSrc, setPdfSrc] = useState(null);
const [showModal, setShowModal] = useState(false);
const [formData, setFormData] = useState(data);
const dispatch = useDispatch();
if (!data) {
    return <div>No data available</div>
  }

  const formatFieldLabel = (key) => {
    if (key === 'appStatus') return 'Application Status'
    if (key === 'pppId') return 'PPP Id'
    if (key === 'sasDistrict') return 'District Sainik and Ardh Sainik Welfare Office'
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
  }

  const formatValue = (key, value) => {
    if (value === null || value === undefined) return 'N/A'
    // Handle all date fields with consistent dd/mm/yyyy format
    if ((key.includes('Date') || key === 'dob') && value) return formatDate(value)
    if (key === 'totalAnnualFamilyIncome' && value) return `Rs. ${value.toLocaleString()}`
    if (key === 'appStatus' && value) {
      return <span className={`text-secondary fw-bold`}>{value}</span>
    }
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return value
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const formatYesNoStatus = (value) => {
    if (value === null || value === undefined || value === '') return 'N/A'
    if (value === 'Yes') return 'Yes'
    if (value === 'No') return 'No'
    return value
  }

  const renderRow = (label, value) => (
    <tr>
      <th className="bg-light" style={{ width: '30%' }}>{label}</th>
      <td>{value}</td>
    </tr>
  )

  const handleDownloadPdf = async () => {
    dispatch(isloading());
    try {
      await downloadRegistrationPdf();
    } finally {
      dispatch(isloading());
    }
  };

  const viewDocument=async(docId)=>{
     try {
dispatch(isloading());
        const res = await AxiosInstance.get(`${BaseUrl}/api/auth/document/${docId}`,
           {
          headers: { 'Content-Type': 'application/json' },
           responseType: 'arraybuffer', 
        });

         const blob = new Blob([res.data], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);

    setPdfSrc(pdfUrl); 
    setShowModal(true); 
        
    } catch (err) {
      toast.error(err.response?.data?.message || "Server error");
    } finally {
      dispatch(isloading());
    }
  }

  return (
    <div className="container">
      <div className="card shadow-lg">
        <div className="card-header text-white d-flex justify-content-between align-items-center" style={{background:"#008d96"}}>
          <h4 className="mb-0">Employee Details - CAPF</h4>
          {showDownloadButton && (
            <button
              type="button"
              className="btn btn-light btn-sm w-25"
              onClick={handleDownloadPdf}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg> Download PDF
            </button>
          )}
        </div>
        <div className="card-body">
          
          {/* Important Information Section */}
          <div className="row mb-4">
            <div className="col-12">
              <h5 className="text-primary mb-3">Basic Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <tbody>
                    {renderRow('Application Status', formatValue('appStatus', data.appStatus))}
                    {renderRow('PPP Id', formatValue('pppId', data.pppId))}
                    {renderRow('Member Id', formatValue('memberId', data.memberId))}
                    {renderRow('Force Number', formatValue('forceNumber', data.forceNumber))}
                    {renderRow('Force Name', formatValue('forceName', data.forceName))}
                    {renderRow('Full Name', formatValue('fullName', data.fullName))}
                    {renderRow('Service', formatValue('service', data.service))}
                    {renderRow('Type', formatValue('type', data.type))}
                    {renderRow('Rank', formatValue('rank', data.rank))}
                    {renderRow('Gender', formatValue('gender', data.gender))}
                    {renderRow('Date Of Birth', formatValue('dob', data.dob))}
                    {renderRow('Mobile', formatValue('mobile', data.mobile))}
                    {renderRow('Email', formatValue('email', data.email))}
                    {renderRow('District Sainik and Ardh Sainik Welfare Office', formatValue('sasDistrict', data.sasDistrict))}
                    {renderRow('State', formatValue('state', data.state))}
                    {renderRow('District', formatValue('district', data.district))}
                    {renderRow('Tehsil', formatValue('tehsil', data.tehsil))}
                    {renderRow('Village', formatValue('village', data.village))}
                    {renderRow('Address', formatValue('address', data.address))}
                    {renderRow('Pin Code', formatValue('pinCode', data.pinCode))}
                    {renderRow('Total Annual Family Income', formatValue('totalAnnualFamilyIncome', data.totalAnnualFamilyIncome))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Additional Information Section */}
          <div className="row">
            <div className="col-12">
              <h5 className="text-primary mb-3">Additional Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <tbody>
                    {renderRow("Father's Name", formatValue('fatherName', data.fatherName))}
                    {renderRow("Mother's Name", formatValue('motherName', data.motherName))}
                    {renderRow('Marital Status', formatValue('maritalStatus', data.maritalStatus))}
                    {renderRow('Alternate Mobile', formatValue('altMobile', data.altMobile))}
                    {renderRow('Benchmark Disability', formatValue('benchmarkDisability', data.benchmarkDisability))}
                    {renderRow('Disability Percentage', formatValue('disabilityPercentage', data.disabilityPercentage))}
                    {renderRow('Caste Category', formatValue('casteCategoryName', data.casteCategoryName))}
                    {renderRow('Caste Category Other', formatValue('casteCategoryOther', data.casteCategoryOther))}
                    {renderRow('Highest Qualification', formatValue('highestQualificationName', data.highestQualificationName))}
                    {renderRow('Qualification Other', formatValue('qualificationOther', data.qualificationOther))}
                    {renderRow('Current Engagement', formatValue('currentEngagementName', data.currentEngagementName))}
                    {renderRow('Engagement Other', formatValue('engagementOther', data.engagementOther))}
                    {renderRow('Income Verified', formatValue('incomeVerified', data.incomeVerified))}
                    {renderRow('Covered Under Socio Economic', formatValue('coveredUnderSocioEconomic', data.coveredUnderSocioEconomic))}
                    {renderRow('Has License', formatValue('hasLicense', data.hasLicense))}
                    {data.licenses?.length > 0 && renderRow(
                      'License Types',
                      data.licenses.map((license) => license.licenseType).join(', ')
                    )}
                    {renderRow('PPO No', formatValue('ppoNo', data.ppoNo))}
                    {renderRow('PPO Date', formatValue('ppoDate', data.ppoDate))}
                    {renderRow('Medical Category', formatValue('medicalCategory', data.medicalCategory))}
                    {renderRow('Enrollment Date', formatValue('enrollmentDate', data.enrollmentDate))}
                    {renderRow('Discharge Date', formatValue('dischargeDate', data.dischargeDate))}
                    {renderRow('Discharge Book No', formatValue('dischargeBookNo', data.dischargeBookNo))}
                    {renderRow('Unit Retired', formatValue('unitRetired', data.unitRetired))}
                    {renderRow('Remarks', formatValue('remarks', data.remarks))}
                    {data.documents && data.documents.map((doc, index) => (
                    <tr key={index}>
                      <th className="bg-light" style={{ width: '30%' }}>
                        {doc.docName}
                      </th>
                      <td>
                        <button type="button" className="btn btn-primary" style={{ width: '40%' }} onClick={() => viewDocument(doc.docId)}>View Document</button>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {data.hasNok === "Yes" && data.nokDetails && (
            <div className="row mt-4">
              <div className="col-12">
                <h5 className="text-primary mb-3">NOK Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>NOK Name</th>
                        <td>{data.nokDetails.nokName || 'N/A'}</td>
                      </tr>
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>Relation</th>
                        <td>{data.nokDetails.relation || 'N/A'}</td>
                      </tr>
                      <tr>
                        <th className="bg-light" style={{ width: '30%' }}>Age</th>
                        <td>{data.nokDetails.age || 'N/A'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {data.experience && data.experience.length > 0 && (
            <div className="row mt-4">
              <div className="col-12">
                <h5 className="text-primary mb-3">Experience Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>Sr. No.</th>
                        <th>Experience Type</th>
                        <th>Designation</th>
                        <th>Agency Name</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>PF Status</th>
                        <th>PF Number</th>
                        <th>ESI Status</th>
                        <th>ESI Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.experience.map((exp, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{exp.experienceType || 'N/A'}</td>
                          <td>{exp.designation || 'N/A'}</td>
                          <td>{exp.agencyName || 'N/A'}</td>
                          <td>{exp.fromDate ? formatDate(exp.fromDate) : 'N/A'}</td>
                          <td>{exp.toDate ? formatDate(exp.toDate) : 'N/A'}</td>
                          <td>{formatYesNoStatus(exp.pf)}</td>
                          <td>{exp.pfNumber || 'N/A'}</td>
                          <td>{formatYesNoStatus(exp.esi)}</td>
                          <td>{exp.esiNumber || 'N/A'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          

        </div>
      </div>
      <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="lg">
        <ModalHeader toggle={() => setShowModal(false)}>Discharge/Retirement Book</ModalHeader>
        <ModalBody style={{ height: "80vh", padding: 0 }}>
          {pdfSrc && (
            <embed
              src={pdfSrc}
              type="application/pdf"
              width="100%"
              height="100%"
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default EmployeeCapfFormView